// Common
import { default as init } from "./common/base";

// Helpers
import { Component } from "./helpers/component";
import { ZEvents } from "./helpers/events";
import { StoreManager } from "./helpers/store";

// Components
import { Toast } from "../../components/toast/toast";
import { Video } from "../../components/video/video";
import { Slider } from "../../components/slider/slider";
import { Header } from "../../components/header/header";
import { NavBar1 } from "../../components/navbar1/navbar1";
import { SearchOverlay } from "../../components/searchoverlay/searchoverlay";
import { OffCanvasNav } from "../../components/offcanvasnav/offcanvasnav";
import { Form } from "../../components/form/form";
import { Icon } from "../../components/icon/icon";
import { RadioCard } from "../../components/radiocard/radiocard";
import { LoadMore } from "../../components/loadmore/loadmore";

//Load app store
const storeManager = new StoreManager();

//Loading events
ZEvents.loadCustomEvents();

// Registering components
Component.register("Header", Header);
Component.register("Video", Video);
Component.register("Slider", Slider);
Component.register("NavBar1", NavBar1);
Component.register("OffCanvasNav",OffCanvasNav);
Component.register("SearchOverlay", SearchOverlay);
Component.register("Form", Form);
Component.register("Toast", Toast);
Component.register("Icon", Icon);
Component.register("RadioCard",RadioCard);
Component.register("LoadMore", LoadMore);

init();